(ns frontend.ui.component.lp-portal.report.overview.big-figures.view
  (:require
   [frontend.ui.component.lp-portal.report.overview.big-figures.style :as style]
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.big-figure.view :refer [big-figure]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]
   [herb.core :refer [<class]]
   [common.util :as cu]))

(defn overview-figures-card
  [{:keys [rich-content rich-content-path figures] :as data}
   {:keys [edit-mode? save-text] :as props}]
  [card {}
   [grid/row {}
    [grid/column {}
     [:div
      {:style (when (= 2 (count figures))
                {:max-width    "40%"
                 :margin-left  "auto"
                 :margin-right "auto"})}
      [grid/row {}
       (->> figures
            (map (fn [[value label]]
                   ^{:key (str ::row "-" label)}
                   [:div {:class (<class style/figure-column (count figures))}
                    [big-figure value label]]))
            (doall))]]
     (text-content/optional-footnote data props)]]])
